<div class="ib-repo-dialog">
    <h2 class="ib-repo-dialog__title">Verify inbound reposition</h2>
    <p class="ib-repo-dialog__trip">Trip {{ data.tripId }}</p>

    <p *ngIf="reasonText" class="ib-repo-dialog__reason">{{ reasonText }}</p>

    <dl class="ib-repo-dialog__details">
        <div class="ib-repo-dialog__detail">
            <dt>Expected airport</dt>
            <dd>{{ data.expectedAirport || '-' }}</dd>
        </div>
        <div *ngIf="data.capturedAirport" class="ib-repo-dialog__detail">
            <dt>Captured airport</dt>
            <dd>{{ data.capturedAirport }}</dd>
        </div>
        <div class="ib-repo-dialog__detail">
            <dt>Expected hours</dt>
            <dd>{{ data.expectedHours ?? '-' }}</dd>
        </div>
        <div *ngIf="data.capturedHours !== null && data.capturedHours !== undefined" class="ib-repo-dialog__detail">
            <dt>Captured hours</dt>
            <dd>{{ data.capturedHours }}</dd>
        </div>
    </dl>

    <div *ngIf="isVerified" class="ib-repo-dialog__verified">
        <app-ds-badge label="Verified" theme="success"></app-ds-badge>
        <span *ngIf="data.verifiedByName || data.verifiedOn" class="ib-repo-dialog__verified-by">
            Verified<ng-container *ngIf="data.verifiedByName"> by {{ data.verifiedByName }}</ng-container
            ><ng-container *ngIf="data.verifiedOn"> on {{ data.verifiedOn | srTimezoneDate }}</ng-container>
        </span>
    </div>

    <form class="ib-repo-dialog__form" [formGroup]="form" (ngSubmit)="save()">
        <ds-input formControlName="verifiedHours" label="Verified hours" type="number" min="0" max="99.99"></ds-input>
        <ds-textarea formControlName="note" label="Note (optional)" [maxlength]="500"></ds-textarea>

        <p *ngIf="errorMessage" class="ib-repo-dialog__error" role="alert">{{ errorMessage }}</p>

        <div class="ib-repo-dialog__actions">
            <ds-button label="Cancel" theme="secondary-gray" size="xl" (buttonClick)="cancel()"></ds-button>
            <ds-button label="Save" size="xl" [isDisabled]="isSaveDisabled" [isLoading]="pending" (buttonClick)="save()"></ds-button>
        </div>
    </form>
</div>
